import { AddToCartEventInterface, CheckoutInterface, EventInterface, GenerateLeadInterface, ItemListInterface, ItemsInterface, PaymentInfoInterface, PurchaseInterface, RemoveFromCartInterface, SelectItemInterface, ShippingInfoInterface, TagInterface, TagManager, UserIdInterface, ViewItemInterface } from 'sih-gtm/build/TagManager'

export interface LoginInfoInterface extends EventInterface {
  event: 'login'
  eventParams: {
    userId: string
    method: string
    source: string
  }

}

export interface CreditCardCheckoutStepInterface extends EventInterface {
  event: 'add_credit_card'
  eventParams: {
  }
  customEventParams?: Record<string, any>
}

export interface AddressCheckoutStepInterface extends EventInterface {
  event: 'add_address'
  eventParams: {
  }
  customEventParams?: Record<string, any>
}

export interface ConfirmationInterface extends EventInterface {
  event: 'subscription_details_confirmation'
  eventParams: {
    currency: string
  }
  customEventParams?: Record<string, any>
}

export interface PlanInterface extends EventInterface {
  event: 'plan_selected'
  eventParams: {
    plan: string
  }
  customEventParams?: Record<string, any>
}

export interface CheckoutCompletedInterface extends EventInterface {
  event: 'checkout_completed'
  eventParams: {
    currency: string
  }
  customEventParams?: Record<string, any>
}
export interface SignupInfoInterface extends EventInterface {
  event: 'sign_up'
  eventParams: {
    email: string
    mobile: string
    method: string
    firstName: string
    lastName: string
    newsletter: string
    source: string
  }
  customEventParams?: Record<string, any>
}

export interface CouponDetailsInterface extends EventInterface {
  event: 'coupon-insert'
  eventParams: {
    couponName: string
    couponType: string
  }

}

export interface DeeplinkDetailsInterface extends EventInterface {
  event: 'app-opened-with-deeplink'
  eventParams: {
    coldStart: boolean
    deeplink: string
  }
  customEventParams?: Record<string, any>
}

export interface DeeplinkErrorInterface extends EventInterface {
  event: 'app-opened-with-deeplink-error'
  eventParams: {
    coldStart: boolean
    deeplink: string
    error: Error
  }
  customEventParams?: Record<string, any>
}

export interface CheckoutUiStatusGapInterface extends EventInterface {
  event: 'checkout_ui_status_gap'
  eventParams: {
    surface: string
    reason: string
    pathname: string
    sessionFlowType: string | null
    stateFlowType: string | null
    hasCurrentUser: boolean
    hasCheckoutStatusId: boolean
    isGuest: boolean
    isHydrated: boolean
    isCheckoutStatusLoading: boolean
  }
}

export interface CartSaveInterface extends EventInterface {
  event: 'cart_save'
  eventParams: {
    currency: string
    value: number
    coupon?: string
    items: ItemsInterface[]
  }
  customEventParams?: Record<string, any>
}

export interface SearchItemInterface extends EventInterface {
  event: 'search'
  eventParams: {
    term: string
  }

}
export class GTMBase {

  eventPrefix: string
  currency: string

  constructor(key: string, eventPrefix = '', currency = 'ZAR') {
    this.eventPrefix = eventPrefix
    this.currency = currency

    const tagManagerArgs: TagInterface = {
      id: key,
      auth: 'wq_Vs41rXxSAk53yLfgWlQ',
      preview: 'env-1',
      domain: 'https://www.googletagmanager.com',
      eventData: undefined,
    }

    TagManager.initialize(tagManagerArgs)
  }

  // protected pageView(page: GAPageView): void {
  //   TagManager.pushEvent({
  //     event: 'pageview',
  //     page,
  //   })
  // }

  protected addPaymentInfo(eventData: PaymentInfoInterface): void {
    TagManager.pushEvent(eventData)
  }

  protected addUserInfo(eventData: UserIdInterface): void {
    TagManager.pushEvent(eventData)
  }

  protected addShippingInfo(eventData: ShippingInfoInterface): void {
    TagManager.pushEvent(eventData)
  }

  protected addToCart(eventData: AddToCartEventInterface): void {
    TagManager.pushEvent(eventData)
  }

  protected beginCheckout(eventData: CheckoutInterface): void {
    TagManager.pushEvent(eventData)
  }

  protected saveCart(eventData: CartSaveInterface): void {
    TagManager.pushEvent(eventData)
  }

  protected subscriptionDetailsConfirmation(eventData: ConfirmationInterface): void {
    TagManager.pushEvent(eventData)
  }

  protected planSelected(eventData: PlanInterface): void {
    TagManager.pushEvent(eventData)
  }

  protected checkoutCompleted(eventData: CheckoutCompletedInterface): void {
    TagManager.pushEvent(eventData)
  }

  protected addCreditCardCheckoutStep(eventData: CreditCardCheckoutStepInterface): void {
    TagManager.pushEvent(eventData)
  }

  protected addAddressCheckoutStep(eventData: AddressCheckoutStepInterface): void {
    TagManager.pushEvent(eventData)
  }

  protected login(eventData: LoginInfoInterface): void {
    TagManager.pushEvent(eventData)
  }

  protected generateLead(eventData: GenerateLeadInterface): void {
    TagManager.pushEvent(eventData)
  }

  protected purchase(eventData: PurchaseInterface): void {
    TagManager.pushEvent(eventData)
  }

  protected removeFromCart(eventData: RemoveFromCartInterface): void {
    TagManager.pushEvent(eventData)
  }

  protected search(eventData: SearchItemInterface): void {
    TagManager.pushEvent(eventData)
  }

  // protected selectContent(params: GASelectContent): void {
  //   TagManager.pushEvent({
  //     event: 'select_content',
  //     params,
  //   })
  // }

  protected selectItem(eventData: SelectItemInterface): void {
    TagManager.pushEvent(eventData)
  }

  protected signUp(eventData: SignupInfoInterface): void {
    TagManager.pushEvent(eventData)
  }

  protected viewItem(eventData: ViewItemInterface): void {
    TagManager.pushEvent(eventData)
  }

  protected viewItemList(eventData: ItemListInterface): void {
    TagManager.pushEvent(eventData)
  }

  protected addCoupon(eventData: CouponDetailsInterface): void {
    TagManager.pushEvent(eventData)
  }

  protected openedAppWithDeeplink(eventData: DeeplinkDetailsInterface): void {
    TagManager.pushEvent(eventData)
  }

  protected openedAppWithDeeplinkError(eventData: DeeplinkErrorInterface): void {
    TagManager.pushEvent(eventData)
  }

  protected checkoutUiStatusGap(eventData: CheckoutUiStatusGapInterface): void {
    TagManager.pushEvent(eventData)
  }

}
